/**
 * Filter-related constants used across the gallery builder
 */

export const FILTER_LABELS = {
  ORIENTATION: 'Print Orientation'
};

export const EXCLUDED_FILTER_LABELS = [
  FILTER_LABELS.ORIENTATION
];

/**
 * Calculates filter count excluding specified labels
 * @param {Object} filters - Active filters object
 * @param {Array<string>} excludedLabels - Labels to exclude from count
 * @returns {number} Filter count
 */
export function getFilterCount(filters, excludedLabels = []) {
  let count = 0;

  Object.entries(filters).forEach(([label, values]) => {
    if (!excludedLabels.includes(label)) {
      count += values.length;
    }
  });

  return count;
}

/**
 * Calculates display filter count (excluding orientation and internal filters)
 * @param {Object} filters - Active filters object
 * @returns {number} Display filter count
 */
export function getDisplayFilterCount(filters) {
  let count = 0;

  Object.entries(filters).forEach(([label, values]) => {
    // Exclude orientation filter and any internal filters (starting with __)
    if (!EXCLUDED_FILTER_LABELS.includes(label) && !label.startsWith('__')) {
      count += values.length;
    }
  });

  return count;
}